import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { NavLink } from "react-router-dom";
import NotificationIcon from "../NotificationIcon";

const SideMenuItem = ({
  path,
  text,
  icon,
  notification,
  type,
  state = null,
}) => {
  return (
    <li>
      <NavLink
        exact
        to={{ pathname: path, state: state }}
        activeClassName="active"
      >
        <div className="text">{text}</div>
        <div className="icon">
          {type === "image" ? (
            <img src={icon} alt="" />
          ) : (
            <FontAwesomeIcon icon={icon} size="lg" />
          )}
          {notification > 0 && (
            <div className="noti">
              <NotificationIcon count={notification} />
            </div>
          )}
        </div>
      </NavLink>
    </li>
  );
};

export default SideMenuItem;
